<template>
  <form @submit.prevent="handleSubmit">
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
      <!-- First Name -->
      <div>
        <label for="first_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          First Name
        </label>
        <input
          id="first_name"
          v-model="form.first_name"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading"
          required>
      </div>

      <!-- Last Name -->
      <div>
        <label for="last_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Last Name
        </label>
        <input
          id="last_name"
          v-model="form.last_name"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading"
          required>
      </div>

      <!-- Email -->
      <div class="sm:col-span-2">
        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Email
        </label>
        <input
          id="email"
          v-model="form.email"
          type="email"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading"
          required>
      </div>

      <!-- Phone -->
      <div>
        <label for="phone" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Phone Number
        </label>
        <input
          id="phone"
          v-model="form.phone"
          type="tel"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- Birthday -->
      <div>
        <label for="birthday" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Birthday
        </label>
        <input
          id="birthday"
          v-model="form.birthday"
          type="date"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- Address -->
      <div class="sm:col-span-2">
        <label for="address" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Address
        </label>
        <input
          id="address"
          v-model="form.address"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- City -->
      <div>
        <label for="city" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          City
        </label>
        <input
          id="city"
          v-model="form.city"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- State -->
      <div>
        <label for="state" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          State
        </label>
        <input
          id="state"
          v-model="form.state"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- Country -->
      <div>
        <label for="country" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Country
        </label>
        <input
          id="country"
          v-model="form.country"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>

      <!-- Zip -->
      <div>
        <label for="zip" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Zip Code
        </label>
        <input
          id="zip"
          v-model="form.zip"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          :disabled="loading">
      </div>
    </div>

    <!-- Submit Button -->
    <div class="mt-6">
      <button
        type="submit"
        :disabled="saving || !hasChanges"
        class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 disabled:opacity-50 disabled:cursor-not-allowed">
        <span v-if="saving" class="flex items-center">
          <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          Saving...
        </span>
        <span v-else>Save changes</span>
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import { isEqual } from 'lodash'

// Props
const props = defineProps({
  profile: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['update'])

// State
const saving = ref(false)
const originalForm = ref({})
const form = reactive({
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  birthday: '',
  address: '',
  city: '',
  state: '',
  country: '',
  zip: ''
})

// Computed
const hasChanges = computed(() => !isEqual(form, originalForm.value))

// Methods
const populateForm = () => {
  Object.keys(form).forEach((key) => {
    form[key] = props.profile[key] || ''
  })
  originalForm.value = { ...form }
}

const handleSubmit = async() => {
  if (!hasChanges.value || saving.value) return

  saving.value = true

  try {
    await emit('update', { profile: { ...form } })
    originalForm.value = { ...form }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to save profile:', error)
  } finally {
    saving.value = false
  }
}

// Watchers
watch(() => props.profile, (newProfile) => {
  if (newProfile && Object.keys(newProfile).length > 0) {
    populateForm()
  }
}, { immediate: true, deep: true })
</script>
